import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SITE, waLink } from "@/lib/site";

const links = [
  { href: "/#profil", label: "Profil" },
  { href: "/projek", label: "Projek", route: true },
  { href: "/#khidmat", label: "Khidmat" },
  { href: "/blog", label: "Blog", route: true },
  { href: "/#mohon", label: "Mohon" },
];

export default function Navbar({ solid = false }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solidStyle = solid || scrolled;

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 ${
        solidStyle
          ? "bg-white/80 backdrop-blur-xl border-b border-slate-200 shadow-[0_4px_20px_rgb(0,0,0,0.03)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 h-16 md:h-20 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-heading text-lg md:text-xl font-extrabold tracking-tight text-[#0A2540]">
            {SITE.agency}
          </span>
          <span className="text-[11px] tracking-wide text-slate-500">
            {SITE.agentName}
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) =>
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-slate-600 hover:text-[#0A2540] transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-slate-600 hover:text-[#0A2540] transition-colors"
              >
                {l.label}
              </a>
            )
          )}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-btn">
            <Button className="h-10 px-5 bg-[#0A2540] hover:bg-[#0d3358] text-white rounded-full transition-transform hover:scale-105">
              <Phone className="mr-2 h-4 w-4" /> Hubungi
            </Button>
          </a>
        </div>

        <button
          className="md:hidden text-[#0A2540]"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-b border-slate-200 px-6 py-4 space-y-3" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-slate-700 font-medium py-1"
            >
              {l.label}
            </a>
          ))}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="block">
            <Button className="w-full bg-[#0A2540] text-white rounded-full">
              <Phone className="mr-2 h-4 w-4" /> Hubungi Saya
            </Button>
          </a>
        </div>
      )}
    </header>
  );
}
